<template>
  <div>
    <a-drawer
      :maskClosable="false"
      width="80%"
      title="功能模块"
      placement="right"
      :closable="true"
      :visible="visible"
      @close="onClose"
    >
      <a-card :bordered="false">
        <div class="table-operations" style="margin-bottom: 16px">
          <a-button type="primary" @click="handleAdd" v-hasPermi="['90e829225dc5cabe661c26152df736e2c:0:c']">
            <a-icon type="plus" />分配
          </a-button>
        </div>
        <a-table :loading="loading" rowKey="moduleId" :columns="columns" :data-source="list" :pagination="false">
          <span slot="moduleName" slot-scope="text, record">
            {{ record.moduleName || '-' }}
          </span>
          <span slot="moduleSystemType" slot-scope="text">
            <a-tag :color="getModuleTypeColor(text)">
              {{ getModuleTypeText(text) }}
            </a-tag>
          </span>
          <span slot="isAllowAllocate" slot-scope="text">
            <a-tag :color="text ? 'green' : 'red'">
              {{ text ? '是' : '否' }}
            </a-tag>
          </span>
          <span slot="isSubAutoIntegrate" slot-scope="text">
            <a-tag :color="text ? 'green' : 'red'">
              {{ text ? '是' : '否' }}
            </a-tag>
          </span>
          <span slot="endTime" slot-scope="text">
            {{ text ? formatTime(text) : '-' }}
          </span>
        </a-table>
      </a-card>
    </a-drawer>
    <module-tenant-form ref="moduleTenantForm" @ok="getList" />
  </div>
</template>

<script>
import { getModuleTenantList } from '@/api/system/module'
import ModuleTenantForm from './ModuleTenantForm.vue'

export default {
  name: 'ModuleTenantDrawer',
  components: {
    ModuleTenantForm,
  },
  data() {
    return {
      visible: false,
      loading: false,
      list: [],
      tenantId: undefined,
      columns: [
        {
          title: '模块名称',
          dataIndex: 'moduleName',
          key: 'moduleName',
          align: 'center',
          width: '15%',
          scopedSlots: { customRender: 'moduleName' },
        },

        {
          title: '是否允许分配',
          dataIndex: 'isAllowAllocate',
          key: 'isAllowAllocate',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'isAllowAllocate' },
        },
        {
          title: '下级自动集成',
          dataIndex: 'isSubAutoIntegrate',
          key: 'isSubAutoIntegrate',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'isSubAutoIntegrate' },
        },
        {
          title: '截止日期',
          dataIndex: 'endTime',
          key: 'endTime',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'endTime' },
        },
      ],
    }
  },
  methods: {
    init(record) {
      this.tenantId = record.id
      this.visible = true
      this.getList()
    },
    async getList() {
      if (!this.tenantId) {
        return
      }
      this.loading = true
      try {
        const res = await getModuleTenantList(this.tenantId)
        if (res && res.data) {
          this.list = res.data
        } else {
          this.list = []
          this.$message.error(res.message || '获取功能模块列表失败')
        }
      } catch (error) {
        console.error('获取功能模块列表失败:', error)
        this.$message.error('获取功能模块列表失败')
        this.list = []
      } finally {
        this.loading = false
      }
    },
    getModuleTypeText(type) {
      const map = {
        0: '平台模块',
        1: '系统内置',
        2: '其它模块',
      }
      return map[type] || '未知'
    },
    getModuleTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'gray'
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    onClose() {
      this.visible = false
      this.list = []
      this.tenantId = undefined
    },
    handleAdd() {
      // 将当前列表中的所有已分配模块信息传递给表单组件，用于回显
      const selectedModules = this.list.map((row) => ({
        moduleId: row.moduleId,
        isAllowAllocate: row.isAllowAllocate || false,
        isSubAutoIntegrate: row.isSubAutoIntegrate || false,
        endTime: row.endTime || null,
      }))
      this.$refs.moduleTenantForm.init({
        id: this.tenantId,
        selectedModules: selectedModules,
      })
    },
  },
}
</script>

<style scoped></style>
